// This drawer reads and updates the Shopify cart; no simulated order state.
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const local = ['127.0.0.1', 'localhost'].includes(location.hostname);
  const sponsorTiers = new Map([
    ['Spry', 'gold'],
    ['Alter Eco', 'gold'],
    ['Free2b', 'gold'],
    ['Beekeeper’s Naturals', 'silver'],
    ['Wild West', 'silver'],
    ['Blake’s', 'silver'],
    ['Zollipops', 'bronze'],
    ['Vegobears', 'bronze']
  ]);
  document.querySelectorAll('.pack-contents-dialog .contents-item').forEach(card => {
    const tier = sponsorTiers.get(card.querySelector('h3')?.textContent.trim());
    const photo = card.querySelector('.contents-photo');
    if (!tier || !photo || photo.classList.contains('contents-sponsor-highlight')) return;
    photo.classList.add('contents-sponsor-highlight', `contents-sponsor-highlight--${tier}`);
  });
  // Local rendering resolves the same featured product image used by Liquid live.
  if (local) document.querySelectorAll('[data-product-image]').forEach(async img => {
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(img.dataset.productImage) + '.js');
      if (!response.ok) return;
      const product = await response.json();
      if (product.featured_image) {
        img.src = product.featured_image;
        img.hidden = false;
        img.parentElement.style.removeProperty('display');
        document.querySelector('[data-product-placeholder="' + img.dataset.productImage + '"]')?.remove();
      }
    } catch (_) { /* Keep the media space if the product cannot be reached. */ }
  });
  const dialog = document.createElement('dialog');
  dialog.className = 'review-side-cart';
  dialog.setAttribute('aria-labelledby', 'review-cart-title');
  dialog.innerHTML = `<header><h2 id="review-cart-title">Your order</h2><button type="button" class="review-cart-close" aria-label="Close cart">×</button></header>
    <p class="review-cart-message" role="status" aria-live="polite"></p>
    <div class="tbtt-box-meter" data-drawer-box-meter></div><div class="review-cart-items"></div>
    <footer><div class="review-cart-savings"></div><p class="review-cart-total"></p>
    <p class="review-cart-delivery tbtt-delivery-notice" role="note"><strong>All orders will now arrive after Halloween.</strong></p>
    <p class="review-cart-note">Shipping included. Review your order and explore optional extras before checkout.</p>
    <a class="review-cart-checkout" href="/cart" hidden>Review order &amp; add extras</a>
    <button type="button" class="review-cart-shop">Keep shopping — explore packs</button></footer>`;
  document.body.append(dialog);
  const items = dialog.querySelector('.review-cart-items');
  const status = dialog.querySelector('.review-cart-message');
  const cartLink = document.querySelector('.review-cart-link');
  let busy = false;
  let returnFocus;
  const money = (amount, currency) => new Intl.NumberFormat('en-US', {style:'currency', currency}).format(amount / 100);
  function open(trigger) {
    if (!dialog.open) {
      returnFocus = trigger;
      dialog.showModal();
      document.body.classList.add('review-cart-open');
    }
  }
  function close() { dialog.close(); }
  dialog.addEventListener('close', () => {
    document.body.classList.remove('review-cart-open');
    returnFocus?.focus();
  });
  dialog.querySelector('.review-cart-close').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right)) close();
  });
  dialog.querySelector('.review-cart-shop').addEventListener('click', () => {
    close();
    const section = document.getElementById('shop-packs');
    section.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    section.querySelector('h2').setAttribute('tabindex', '-1');
    section.querySelector('h2').focus({preventScroll:true});
  });
  async function request(path, body) {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store',
      headers: body ? {'Content-Type':'application/json'} : {}, body: body ? JSON.stringify(body) : undefined});
    if (response.status === 429) throw new Error('The store is busy. Please wait a moment, then reopen your cart.');
    let data;
    try { data = await response.json(); }
    catch (_) { throw new Error('We couldn’t load your order. Please close and reopen the cart.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'We couldn’t update your order. Please try again.');
    return data;
  }
  function render(cart) {
    window.tbttBoxMeter?.render(dialog.querySelector('[data-drawer-box-meter]'), cart.items);
    items.replaceChildren();
    cartLink.textContent = cart.item_count ? `Cart (${cart.item_count})` : 'Cart';
    cartLink.setAttribute('aria-label', `View your cart, ${cart.item_count} items`);
    const currency = cart.currency || 'USD';
    if (!cart.items.length) items.textContent = 'Your cart is empty. Choose a pack to start your order.';
    cart.items.forEach(item => {
      const row = document.createElement('article');
      row.className = 'review-cart-item';
      const media = document.createElement('div');
      media.className = 'review-cart-media';
      media.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image; img.alt = '';
        img.addEventListener('error', () => img.remove(), {once:true});
        media.append(img);
      }
      row.append(media);
      const detail = document.createElement('div');
      detail.className = 'review-cart-detail';
      const title = document.createElement('h3'); title.textContent = item.product_title;
      const price = document.createElement('p'); price.textContent = money(item.final_line_price, currency);
      detail.append(title, price);
      const controls = document.createElement('div'); controls.className = 'review-cart-quantity';
      function quantityButton(label, text, quantity) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = text;
        button.setAttribute('aria-label', `${label} ${item.product_title}`);
        button.addEventListener('click', () => update('cart/change.js', {id:item.key, quantity}));
        return button;
      }
      const count = document.createElement('span'); count.textContent = item.quantity;
      controls.append(quantityButton('Decrease quantity of', '−', item.quantity - 1), count,
        quantityButton('Increase quantity of', '+', item.quantity + 1), quantityButton('Remove', 'Remove', 0));
      detail.append(controls); row.append(detail); items.append(row);
    });
    dialog.querySelector('.review-cart-total').textContent = `Subtotal: ${money(cart.total_price, currency)}`;
    const savings = dialog.querySelector('.review-cart-savings');
    savings.replaceChildren();
    if (cart.total_discount > 0) {
      const total = document.createElement('strong');
      total.textContent = `You’re saving ${money(cart.total_discount, currency)}`;
      savings.append(total);
      const titles = new Set([
        ...(cart.cart_level_discount_applications || []).map(discount => discount.title || discount.discount_application?.title),
        ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(
          allocation => allocation.discount_application?.title))
      ].filter(Boolean));
      const detail = document.createElement('div');
      detail.textContent = [...titles].join(' · ') || 'Discounts applied';
      savings.append(detail);
    }
    const checkout = dialog.querySelector('.review-cart-checkout');
    checkout.hidden = !cart.item_count;
    // Local preview has its own real Shopify session. A permalink carries its items to the store.
    const permalink = 'https://trickedbythetreat.com/cart/' + cart.items.map(i => `${i.variant_id}:${i.quantity}`).join(',');
    checkout.href = local ? permalink + '?storefront=true' : root + 'cart';
  }
  function lock(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    document.querySelectorAll('.review-order-form button, .review-cart-quantity button').forEach(button => button.disabled = value);
    dialog.querySelectorAll('.review-cart-checkout').forEach(a => {
      a.setAttribute('aria-disabled', String(value));
      a.tabIndex = value ? -1 : 0;
    });
  }
  dialog.querySelectorAll('.review-cart-checkout').forEach(a => a.addEventListener('click', e => {if (busy) e.preventDefault();}));
  async function update(path, body, trigger) {
    if (busy) return;
    const focusedLabel = dialog.contains(document.activeElement) ? document.activeElement.getAttribute('aria-label') : null;
    lock(true); open(trigger); status.textContent = body ? 'Updating your order…' : 'Loading your order…';
    let added = false;
    try {
      if (body) { await request(path, body); added = path === 'cart/add.js'; }
      render(await request('cart.js'));
      status.textContent = added ? 'Added to your order.' : '';
    } catch (error) {
      dialog.querySelector('.review-cart-checkout').hidden = true;
      status.textContent = added ? 'Your pack was added, but the cart couldn’t refresh. Close and reopen the cart to refresh it.' : error.message;
    } finally {
      lock(false);
      if (focusedLabel && dialog.open) {
        const target = Array.from(dialog.querySelectorAll('button')).find(b => b.getAttribute('aria-label') === focusedLabel);
        (target || dialog.querySelector('.review-cart-close')).focus();
      }
    }
  }
  document.querySelectorAll('.review-order-form').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      update('cart/add.js', {items:[{id:Number(form.elements.id.value), quantity:Number(form.elements.quantity.value)}]}, form.querySelector('button'));
    });
  });
  cartLink.setAttribute('aria-haspopup', 'dialog');
  cartLink.addEventListener('click', event => {event.preventDefault(); update(null, null, cartLink);});
  // Refresh the count when returning from the cart or checkout.
  window.addEventListener('pageshow', () => {if (!busy) request('cart.js').then(cart => {if (!busy) render(cart);}).catch(() => {});});
})();
